export default {
    props: {
        open: Boolean,
    },
    model: {
        prop: 'open',
        event: 'updateOpen',
    },
    computed: {
        isOpen: {
            get() {
                return this.open
            },
            set(open) {
                this.$emit('updateOpen', open)
            },
        },
    },
    methods: {
        close() {
            this.$emit('updateOpen', false)
        },
    },
}
